export default __webpack_public_path__ + "static/media/oi_6.63f33cb5.mp3";